// eslint-disable-next-line import/no-unresolved
import { createRouter, createWebHistory } from 'vue-router';

// Import components
// eslint-disable-next-line import/no-unresolved
import DiscogsCallback from '@/components/DiscogsCallback.vue';
// eslint-disable-next-line import/no-unresolved
import LoginForm from '@/components/LoginForm.vue';
import configService from '@/services/remoteConfig';
import DiscogsMain from '../components/DiscogsMain.vue';
import ShufflePage from '../components/ShufflePage.vue';
import TaggingPage from '../components/TaggingPage.vue';

// Define routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: DiscogsMain,
    meta: { requiresAuth: true },
  },
  {
    path: '/shuffle',
    name: 'Shuffle',
    component: ShufflePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/tagging',
    name: 'Tagging',
    component: TaggingPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginForm,
    meta: { guest: true },
  },
  {
    path: '/callback',
    name: 'DiscogsCallback',
    component: DiscogsCallback,
    meta: { callback: true },
  },
  // Add other routes as needed
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Check for Discogs tokens in localStorage
const hasDiscogsTokens = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('discogs_auth'));
    if (!authData || !authData.accessToken || !authData.accessTokenSecret) {
      return false;
    }

    // Check if tokens are expired (24 hours)
    const now = Date.now();
    const tokenTime = authData.timestamp || 0;
    const TOKEN_EXPIRY = configService.get('tokenExpiryTime'); // Get from Remote Config

    return (now - tokenTime) < TOKEN_EXPIRY;
  } catch (error) {
    console.error('Error checking Discogs tokens:', error);
    return false;
  }
};

// Navigation guards
router.beforeEach(async (to, from, next) => {
  console.log('Router guard triggered for path:', to.path);

  // Skip auth for callback route
  if (to.meta.callback) {
    console.log('Callback route - allowing without auth check');
    return next();
  }

  // Skip auth for login route
  if (to.meta.guest) {
    // If user is already authenticated, redirect to home
    if (hasDiscogsTokens()) {
      console.log('Already authenticated, redirecting to home');
      return next({ name: 'Home' });
    }

    console.log('Guest route - proceeding without auth check');
    return next();
  }

  // For protected routes, check if user has Discogs tokens
  if (to.meta.requiresAuth) {
    if (!hasDiscogsTokens()) {
      console.log('No Discogs tokens found, redirecting to login');
      return next({ name: 'Login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } });
    }

    console.log('User has Discogs tokens, allowing access');
    return next();
  }

  // Allow access to any other routes
  return next();
});

export default router;
